/**
 * Full list: https://en.wikipedia.org/wiki/Date_format_by_country
 * Canada specific: https://en.wikipedia.org/wiki/Date_and_time_notation_in_Canada
 * South Africa specific: https://en.wikipedia.org/wiki/Date_and_time_notation_in_South_Africa
 */var DateInputFormats;
(function (DateInputFormats) {
  DateInputFormats["DMY"] = 'dd/MM/yyyy';
  DateInputFormats["MDY"] = 'M/d/yyyy';
  DateInputFormats["YMD"] = 'yyyy/MM/dd';
})(DateInputFormats || (DateInputFormats = {}));
var DateInputPlaceholders;
(function (DateInputPlaceholders) {
  DateInputPlaceholders["DMY"] = 'dd/mm/yyyy';
  DateInputPlaceholders["MDY"] = 'mm/dd/yyyy';
  DateInputPlaceholders["YMD"] = 'yyyy/mm/dd';
})(DateInputPlaceholders || (DateInputPlaceholders = {}));
var DateInputParsings;
(function (DateInputParsings) {
  DateInputParsings["DMY"] = 'dd/MM/yyyy';
  DateInputParsings["MDY"] = 'MM/dd/yyyy';
  DateInputParsings["YMD"] = 'yyyy/MM/dd';
})(DateInputParsings || (DateInputParsings = {}));
var DatePickerPlacements;
(function (DatePickerPlacements) {
  DatePickerPlacements["BottomEnd"] = 'bottom-end';
  DatePickerPlacements["BottomStart"] = 'bottom-start';
  DatePickerPlacements["RightStart"] = 'right-start';
  DatePickerPlacements["TopEnd"] = 'top-end';
  DatePickerPlacements["TopStart"] = 'top-start';
})(DatePickerPlacements || (DatePickerPlacements = {}));
export { DateInputFormats, DateInputParsings, DateInputPlaceholders, DatePickerPlacements };